import { useState, Suspense, useRef, useEffect } from 'react';
import AppLoading from '../app-loading/app-loading';
import { Toast } from 'primereact/toast';
import PaymentLinkListDataTable from './resend-payment-link-Datatable';
import orderServices from '../../services/orders/orderservice';

interface DataTableProps {
  dateFilter: any;
  onDataLoaded?: (data: any[]) => void;
  onFlagCacheUpdate?: (cache: Record<number, any | null>) => void;
  refreshCount?: number;
  onPaymentSuccess?: () => void;
}

const PaymentLinkResendList: React.FC<DataTableProps> = (props) => {
  const [loading, setLoading] = useState(false);
  const [paymentLinkList, setPaymentLinkList] = useState<any>(null)
  const toast = useRef<Toast>(null);
  const { dateFilter, onDataLoaded, onFlagCacheUpdate, refreshCount, onPaymentSuccess } = props;
  const startDate = dateFilter?.startDate;
  const endDate = dateFilter?.endDate;
  const userId = dateFilter?.userId;

  useEffect(() => {
    if (!startDate && !endDate) return;
    setLoading(true);
    orderServices.getPaymentLinkList({ dateFilter: { startDate, endDate, userId } }).then((response: any) => {
      if (response && response.length > 0) {
        setPaymentLinkList(response);
        onDataLoaded?.(response);
        setLoading(false)
      }
      else {
        setPaymentLinkList(response ?? []);
        onDataLoaded?.(response ?? []);
        setLoading(false)
      }
    });
  }, [startDate, endDate, userId, refreshCount]);

  return (
    <Suspense fallback={<AppLoading />}>
      <Toast ref={toast} />
      <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
        <div className="col-12">
          {
            paymentLinkList != null ? <PaymentLinkListDataTable dataList={paymentLinkList} onFlagCacheUpdate={onFlagCacheUpdate} onPaymentSuccess={onPaymentSuccess} /> :
              " "
          }
        </div>
      </div>
      {loading && <AppLoading />}
    </Suspense>
  )

}

export default PaymentLinkResendList;